import React from "react";
import Card from "components/card";
import { 
    GraduationCap,
    Calendar,
 } from "lucide-react";
import AccessButton from "components/button/accessbutton";
import { courses } from "./Courses";

const MyTraining = () => {
    return (
        <Card className="text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 bg-white">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6 pb-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="p-2 rounded-full bg-gradient-to-br from-purple-500 to-pink-500">
                            <GraduationCap className="w-5 h-5 text-white" />
                        </div>
                        <div>
                            <h4 className="text-[16px]">
                                My Training
                            </h4>
                            <p className="text-slate-700 text-[11px]">
                                Courses and certifications
                            </p>
                        </div>
                    </div>
                    <AccessButton
                        label="Browse"
                        to="/console/browse-trainings"
                        btnClass="btn-browse"
                    />
                </div>
            </div>
            <div className="px-6 pb-6 pt-2">
                    <div className="space-y-2">
                        {courses.map((course, index) => (
                            <div 
                                key={index}
                                className="p-2.5 rounded-xl border border-slate-200 hover:shadow-md transition-all"
                            >
                                <div className="flex items-start justify-between gap-2 mb-1.5">
                                    <p className="text-[12px] font-medium">
                                        {course.title}
                                    </p>
                                    <span className={`training-status ${course.status.toLowerCase().replace(/\s+/g, "-")}`}>
                                        {course.status}
                                    </span>
                                </div>
                                <div className="flex items-center gap-1.5 mb-1.5">
                                    <Calendar className="w-3 h-3 text-slate-700" />
                                    <span className="text-[10px] text-slate-700">{course.date}</span>
                                </div>
                                <div className="space-y-0.5">
                                    <div className="w-full bg-slate-200 dark:bg-zinc-700 rounded-full h-1.5">
                                        <div 
                                            className="bg-gradient-to-r from-purple-500 to-pink-500 dark:from-purple-600 dark:to-pink-600 h-1.5 rounded-full"
                                            style={{ width: `${course.progress}%` }}
                                        >
                                        </div>
                                    </div>
                                    <p className="text-[9px] text-slate-700">
                                        {course.progress}% complete
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
        </Card>
    )
};
export default MyTraining;